module.exports = __webpack_public_path__ + "static/media/2-Y.2628a183.mp3";